export default __webpack_public_path__ + "static/media/folio-single.61b8c0cd.svg";